module.exports = __webpack_public_path__ + "static/media/arrow-left.7096e827.svg";